import styled from 'styled-components';
import Column from '@sdk/components/ui/spacing/Column';

export const ScrollableArea = styled(Column)<{ scrollLocked: boolean }>`
  max-height: 500px;
  overflow-x: hidden;
  overflow-y: auto;
  margin-left: -20px;
  margin-right: -20px;
  padding-left: 20px;
  padding-right: 20px;

  ${({ scrollLocked }) => (scrollLocked ? `overflow-y: hidden` : '')}
`;
